import React, { useState } from "react";
import {
    TextField,
    Button,
    CircularProgress,
    MenuItem, FormLabel, RadioGroup, FormControlLabel, Radio
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormAddSmmDomain = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [data, setData] = useState({
      domain: "",
      price: 0,
      description: "",
      is_active: 1,
      is_sold: 0,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();
    for (let key in data) {
      if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.SmmDomain.Add,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/SmmDomains");
      }
    } catch (error) {
      console.error("Submission error:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
          {/* Name Field */}
          <TextField
              fullWidth
              margin="normal"
              label="Domain url"
              name="domain"
              required
              autoComplete="off"
              value={data.domain}
              onChange={handleInputChange}
              variant="outlined"
              helperText={ "Add the domain url without http:// or https://"}
          />

          {/* Identifier Field */}
          <TextField
              fullWidth
              margin="normal"
              label="Description"
              name="description"
              required
              autoComplete="off"
              value={data.description}
              onChange={handleInputChange}
              variant="outlined"
              helperText={ " "}
          />

          {/* Default Message Field */}
          <TextField
              fullWidth
              margin="normal"
              label="Price"
              name="price"
              required
              type={"number"}
              autoComplete="off"
              value={data.price}
              onChange={handleInputChange}
              variant="outlined"
          />
            <div className="w-full flex items-center justify-start gap-x-3">
                <FormLabel sx={{ fontWeight: "bold" }} component="legend">
                    active :
                </FormLabel>
                <RadioGroup
                    name="is_active"
                    value={data?.is_active}
                    onChange={handleInputChange}
                    row
                >
                    <FormControlLabel value="1" control={<Radio />} label="Yes" />
                    <FormControlLabel value="0" control={<Radio />} label="No" />
                </RadioGroup>
            </div>
        </div>

        {/* Submit Button */}
        <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={isLoadingSubmit}
            color="primary"
            sx={{
              display: isLoadingSubmit ? "flex" : "block",
              marginTop: 2,
              width: "20%",
              marginX: "auto",
              fontWeight: "bold",
              justifyContent: "center",
            }}
        >
          {isLoadingSubmit ? (
              <CircularProgress size={24} color="inherit" />
          ) : (
              "Add Smm Domain"
          )}
        </Button>
      </form>
  );
};